const DEBUG_STORAGE_KEY = "scheduleDraftTimelineDebug";

function isStorageDebugEnabled() {
    if (typeof window === "undefined" || !window.localStorage) {
        return false;
    }

    try {
        return window.localStorage.getItem(DEBUG_STORAGE_KEY) === "1";
    } catch (error) {
        return false;
    }
}

export function isScheduleDraftTimelineDebugEnabled() {
    return process.env.NODE_ENV === "development" || isStorageDebugEnabled();
}

export function debugScheduleDraftTimeline(scope, payload) {
    if (!isScheduleDraftTimelineDebugEnabled()) {
        return;
    }

    console.log(`[ScheduleDraft Timeline][${scope}]`, payload);
}

export { DEBUG_STORAGE_KEY };
